var d3 = require("d3-selection");

var CenterComponent = function (plot, defs, moduleOptions, data) {
    var center;

    function renderCircle() {
        center = plot
            .append("g")
            .attr("class", "pcg-center");

        var circleGradient = defs.append("radialGradient")
            .attr("id", "radialGradient__circle");

        circleGradient.append("stop").attr("stop-color", "#62b5e7").attr("offset", 0);
        circleGradient.append("stop").attr("stop-color", "#cfe9fa").attr("offset", 0.5);
        circleGradient.append("stop").attr("stop-color", "#eef6fd").attr("offset", 1);

        var circle = center
            .selectAll(".pcg-center__circle")
            .data([null])
            .enter().append("circle")
            .attr("class", "pcg-center__circle")
            .attr("r", moduleOptions.centreRadius)
            .attr("stroke", "transparent")
            .attr("stroke-width", 2)
            .attr("fill", `url(#${circleGradient.attr("id")})`);
    }

    function renderText() {
        var textGroup = center.append("g")
            .attr("class", "pcg-center__title");

        var baseCenterTextPoint = moduleOptions.centreRadius / Math.sqrt(2);

        var centerTextAttrs = {
            "font-size": 12,
            "font-weight": "bold",
            "text-anchor": "middle"
        };

        if (data.mainAction) {
            var centerTextData = [data]
                .map(d => d3.transformLineText(d,
                    plot,
                    -1 * baseCenterTextPoint,
                    -1 * baseCenterTextPoint,
                    1 * baseCenterTextPoint,
                    -1 * baseCenterTextPoint,
                    d => d.mainAction.title,
                    centerTextAttrs)
                );

            var lines = d3.drawTextByPath(textGroup, centerTextData, "pcg-title-line", centerTextAttrs);
            d3.centerTextInCircle(lines, moduleOptions.centreRadius);
        }
    }

    function renderArrows() {
        var arc = d3.arc()
            .innerRadius(moduleOptions.centreRadius + 15)
            .outerRadius(moduleOptions.centreRadius + 15)
            .startAngle(-1 * moduleOptions.angle)
            .endAngle(moduleOptions.angle)
            .padAngle(0.25)();

        var arrowsGroup = center.append("g")
            .attr("class", "pcg-center__arrows")

        var arc = arrowsGroup.append("path")
            .attr("class", "arc")
            .attr("d", d3.toSingleDirectionArc(arc))
            .attr("stroke-width", 3)
            .attr("stroke", "#9d9d9d")
            .attr("fill", "none");

        var leftArrow = arrowsGroup.append("path")
            .attr("d", "M-49 -2 L-57 -23 L-42,-23 Z")
            .attr("stroke-width", 3)
            .attr("stroke", "none")
            .attr("fill", "#9d9d9d")
            .attr("transform", "matrix(1,0.34,-0.34,1,-3,15)");

        var rightArrow = arrowsGroup.append("path")
            .attr("d", "M49 -2 L57 -23 L42,-23 Z")
            .attr("stroke-width", 3)
            .attr("stroke", "none")
            .attr("fill", "#9d9d9d")
            .attr("transform", "matrix(1,-0.34,0.34,1,3,15)");
    }

    function bindEvents() {
        var hasValidLink = data.mainAction && "#" !== data.mainAction.link;
        if (!hasValidLink) {
            return;
        }

        var circleNode = center.select(".pcg-center__circle").node();
        var circleNodeClone = d3.select(circleNode.parentNode.insertBefore(circleNode.cloneNode(true), null));

        circleNodeClone
            .attr("class", `${circleNodeClone.attr("class")}~shadow`)
            .attr("fill", "transparent")
            .attr("cursor", "pointer")
            .on("click", function (d) {
                window.open(data.mainAction.link, data.mainAction.linkTarget || "_self");
            });
    }

    this.render = function () {
        renderCircle();
        renderText();
        renderArrows();
        bindEvents();
    }
}

module.exports = CenterComponent;
